/** Fotos de fundo do login — coloque os arquivos em client/public/images/login/ */
export const LOGIN_BACKGROUND_IMAGES = [
  '/images/login/meeting-01.webp',
  '/images/login/meeting-02.webp',
  '/images/login/meeting-03.webp',
  '/images/login/meeting-04.webp',
  '/images/login/meeting-05.webp',
  '/images/login/meeting-06.webp',
] as const;

export const LOGIN_BACKGROUND_INTERVAL_MS = 3000;
